import { render, staticRenderFns } from "./screenInfoSpot.vue?vue&type=template&id=68a40f08&scoped=true&"
import script from "./screenInfoSpot.vue?vue&type=script&lang=js&"
export * from "./screenInfoSpot.vue?vue&type=script&lang=js&"
import style0 from "./screenInfoSpot.vue?vue&type=style&index=0&id=68a40f08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a40f08",
  null
  
)

export default component.exports